export default __webpack_public_path__ + "static/media/iconCross.74000d79.svg";